import * as Yup from "yup";

export const DesignationValidationSchema = Yup.object().shape({
  designation_name: Yup.string().required("Field is required"),
});

export const AddDesignationInitialValues = {
  designation_name: "",
};
